module.exports = __webpack_public_path__ + "img/c13df19.png";